import React from "react";

import { InvoiceServiceOrderDto, ServiceOrderDto } from "services/serviceOrders/restModels";

import { ActButton, Documents, ReceiptLink } from "../styles";

interface OrderDocumentsProps {
    order: ServiceOrderDto;
    busy: boolean;
    onOpenInvoice: (invoice: InvoiceServiceOrderDto) => void;
    onOpenAct: (invoice: InvoiceServiceOrderDto) => void;
}

// Клик не доходит до строки: в таблице платежей она сама ведёт на карточку заведения.
export const OrderDocuments = ({ order, busy, onOpenInvoice, onOpenAct }: OrderDocumentsProps) => {
    if (order.type === "Card") {
        if (!order.receiptLink) return <>—</>;

        return (
            <Documents onClick={(event) => event.stopPropagation()}>
                <ReceiptLink href={order.receiptLink} target="_blank" rel="noreferrer">
                    Чек
                </ReceiptLink>
            </Documents>
        );
    }

    return (
        <Documents onClick={(event) => event.stopPropagation()}>
            <ActButton type="button" disabled={busy} onClick={() => onOpenInvoice(order)}>
                Счёт
            </ActButton>
            {order.status === "Paid" && (
                <ActButton type="button" disabled={busy} onClick={() => onOpenAct(order)}>
                    Акт
                </ActButton>
            )}
        </Documents>
    );
};
